import { render, staticRenderFns } from "./ModuleBalance.vue?vue&type=template&id=4ae2ad32&"
import script from "./ModuleBalance.vue?vue&type=script&lang=js&"
export * from "./ModuleBalance.vue?vue&type=script&lang=js&"
import style0 from "./ModuleBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports